import {
  Box,
  BoxProps,
  Button,
  CheckBox,
  ColorOptions,
  convertHexToRGBA,
  Image,
  Loader,
  ModBox,
  Spacer,
  Text
} from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { Dimensions, Linking, ScrollView, ScrollViewProps, ViewStyle } from 'react-native'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { SvgImage } from '../../comps/SvgImage'
import { ToastPosition, ToastType } from '../../comps/Toast'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { APIEndPoints } from '../../network/APIEndpoints'
import { Colors, getFromStore, storeData } from '../../util/util'

const modalData = {
  INIT: {
    title: 'Request for Bill Payment Agent',
    description: "You'll  be notified once the request is approved.",
    actionLabel: 'Register Now',
  },
  PENDING: {
    title: 'Bill payment agent request is pending',
    description: "Request processing will take 2-3 Working days. You'll  be notified once approved for Bill Payment.",
    actionLabel: 'Okay, Got it.',
  },
  ACTIVE: {
    title: 'Congratulations! Your BillPay Agent ID is created successfully',
    description: 'Now you can earn extra by making Bill Payments for your customers.',
    actionLabel: 'Proceed to Bill Payments',
    iconName: 'SuccessIconFilled',
  },
}

const height = Dimensions.get('screen').height

const NewUserModalContent = ({ setIsChecked, setShowTerms, checked, onDismiss }: any) => {
  return (
    <Box>
      <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={5}>
        <ModBox width={'70%'}>
          <Text fontFamily="JioType-Black" color={Colors.BLACK_21 as ColorOptions} fontSize={24} lineHeight={32}>
            Become a
          </Text>
          <Text fontFamily="JioType-Black" color={'PRIMARY'} fontSize={24} lineHeight={32}>
            Bill Payment Agent
          </Text>
          <Text fontFamily="JioType-Black" color={Colors.BLACK_21 as ColorOptions} fontSize={24} lineHeight={32}>
            with zero fees & grow your earnings
          </Text>
        </ModBox>
      </Box>

      <Spacer size={32} direction="vertical" />
      <LinearGradientContainer
        customStyle={
          {
            borderRadius: 16,
            overflow: 'hidden',
          } as ViewStyle
        }
        angle={106}
        useAngle={true}
        colorArray={['#faf1e3', '#fefdfb']}
        direction="HORIZONTAL">
        <Box pv={16} ph={16} maxWidth={'95%'}>
          <Box flexDirection={'row'} justify="flex-start">
            <Box pl={3}>
              <SvgImage color={Colors.SECONDARY} imageName="TouchIcon" />
            </Box>
            <Spacer size={16} direction="horizontal" />
            <Text fontFamily={'JioType-Medium'} fontSize={14} lineHeight={20} color={'BLACK'}>
              Click on ‘Register Now’ button.
            </Text>
          </Box>
          <Box
            height={20}
            marginVertical={5}
            borderLeftWidth={0.8}
            borderStyle="dashed"
            borderColor={convertHexToRGBA(Colors.SECONDARY, 50) as ColorOptions}
            marginLeft={12}
          />
          <Box flexDirection={'row'} justify="flex-start">
            <Box>
              <SvgImage color={Colors.SECONDARY} imageName="PaymentIcon" />
            </Box>
            <Spacer size={16} direction="horizontal" />
            <Text fontFamily={'JioType-Medium'} fontSize={14} lineHeight={20} color={'BLACK'}>
              Make Bill Payments for your customer.
            </Text>
          </Box>
          <Box
            height={20}
            marginVertical={5}
            borderLeftWidth={0.8}
            borderStyle="dashed"
            borderColor={convertHexToRGBA(Colors.SECONDARY, 50) as ColorOptions}
            marginLeft={12}
          />
          <Box flexDirection={'row'}>
            <Box>
              <SvgImage color={Colors.SECONDARY} imageName="RupeeIconFilled" />
            </Box>
            <Spacer size={16} direction="horizontal" />
            <Text numberOfLines={3} fontFamily={'JioType-Medium'} fontSize={14} lineHeight={20} color={'BLACK'}>
              Collect amount from customers with convenience fee.
            </Text>
          </Box>
        </Box>
      </LinearGradientContainer>

      <Spacer size={40} direction="vertical" />
      <Box flexDirection={'row'} align="center" justify="space-between">
        <Box maxWidth={80} align="center" justify="center">
          <SvgImage color={'#999999'} imageName="InstantOnboard" />
          <Spacer size={8} direction="vertical" />
          <Text
            textAlign="center"
            fontFamily={'JioType-Medium'}
            fontSize={12}
            lineHeight={20}
            color={'#999999' as ColorOptions}>
            Instant Onboarding
          </Text>
        </Box>
        <Box maxWidth={80} align="center" justify="center">
          <SvgImage color={'#999999'} imageName="NoAdditionalCharges" />
          <Spacer size={8} direction="vertical" />
          <Text
            textAlign="center"
            fontFamily={'JioType-Medium'}
            fontSize={12}
            lineHeight={20}
            color={'#999999' as ColorOptions}>
            No Additional Charges
          </Text>
        </Box>
        <Box maxWidth={80} align="center" justify="center">
          <Image width={80} height={27} source={'npci'} resizeMode="contain" />
          <Spacer size={8} direction="vertical" />
          <Text
            textAlign="center"
            fontFamily={'JioType-Medium'}
            fontSize={12}
            lineHeight={20}
            color={'#999999' as ColorOptions}>
            Trusted by NPCI
          </Text>
        </Box>
      </Box>

      <Spacer size={46} direction="vertical" />
      <ModBox flexDirection={'row'} align="center">
        <CheckBox checked={checked} onChecked={(isChecked) => setIsChecked(isChecked)} />
        <Spacer size={10} direction="horizontal" />
        <Text lineHeight={20} fontFamily="JioType-Medium" fontSize={14} color={Colors.PRIMARY_GREY}>
          I agree to bill payment{' '}
        </Text>
        <Spacer size={2} direction="horizontal" />
        <Box
          justify="center"
          align="center"
          underlayColor={'TRANSPARENT'}
          testID="setShowTerms"
          onPress={() => setShowTerms(true)}>
          <Text color="PRIMARY" lineHeight={20} fontFamily="JioType-Bold" fontSize={14}>
            Terms & Conditions
          </Text>
        </Box>
      </ModBox>
    </Box>
  )
}

const ActiveUserModal = ({
  title,
  description,
  onProceedBillPayment,
  iconName,
}: {
  title: string
  description: string
  iconName: string
  onProceedBillPayment: () => void
}) => {
  return (
    <Box>
      <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={5}>
        <Box width={'90%'}>
          <SvgImage imageName={iconName} />
          <Spacer direction="vertical" size={16} />
          <Text fontFamily="JioType-Black" fontSize={24} lineHeight={28} color={Colors.BLACK_14 as ColorOptions}>
            {title}
          </Text>
          <Spacer direction="vertical" size={10} />
          <Text fontFamily="JioType-Medium" lineHeight={20} fontSize={14} color={Colors.PRIMARY_GREY}>
            {description}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export const BillPaymentModal = ({ onDismiss, onProceed, showBillPaymentModal }: any) => {
  const [checked, setIsChecked] = useState(false)
  const [isLoading, setIsLoading] = useState(showBillPaymentModal)
  const [type, setUserType] = useState(null)
  const navigation = useNavigation()

  const { searchAgent, onboardAgent, mid } = useStores((store) => ({
    searchAgent: store.billPayments.searchAgent,
    onboardAgent: store.user.onboardAgent,
    mid: store?.user.selectedMid,
  }))

  const [searchAgentApi, { state: searchMerchantState, data: searchMerchantData }] = useLazyApiData(searchAgent)
  const [onboardAgentApi, { state: onboardAgentState, data: onboardAgentData }] = useLazyApiData(onboardAgent)

  useEffect(() => {
    if (showBillPaymentModal) {
      searchAgentApi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showBillPaymentModal])

  useEffect(() => {
    if (onboardAgentState === 'fulfilled') {
      const agentStatus = onboardAgentData?.status
      if (agentStatus === 'ALREADY_ONBOARDED') {
        setIsLoading(false)
        onDismiss()
        const message = onboardAgentData?.reasonMessage
        RootStore?.response?.setCustomToast({
          message: message ?? 'Agent is already onboarded.',
          color: defaultColors.RED,
          position: ToastPosition.BOTTOM,
          toastType: ToastType.ACTION_VIEW,
        })
      } else if (agentStatus === 'ACTIVE') {
        // show congrats modal
        setUserType(agentStatus)
        setIsLoading(false)
      } else if (agentStatus === 'PENDING') {
        // show pending modal view
        setUserType(agentStatus)
        setIsLoading(false)
      } else if (agentStatus === 'FAILED') {
        setIsLoading(false)
        setUserType(agentStatus)
        onDismiss()
        const message = onboardAgentData?.reasonMessage
        RootStore?.response?.setCustomToast({
          message: message,
          color: defaultColors.RED,
          position: ToastPosition.BOTTOM,
          toastType: ToastType.ACTION_VIEW,
        })
      }
    } else if (onboardAgentState === 'pending') {
      setIsLoading(true)
    } else if (onboardAgentState === 'rejected') {
      setIsLoading(false)
      onDismiss()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onboardAgentState])

  useEffect(() => {
    if (searchMerchantState === 'fulfilled') {
      if (searchMerchantData?.status === 'ACTIVE') {
        onDismiss()
        naviagateToBillPayment()
      } else if (searchMerchantData?.status === 'PENDING') {
        setIsLoading(false)
        setUserType(searchMerchantData?.status)
      } else if (searchMerchantData?.status === 'NOT AVAILABLE') {
        setIsLoading(false)
        setUserType('INIT')
      } else if (searchMerchantData?.status === 'FAILED') {
        setIsLoading(false)
        onDismiss()
        const message = searchMerchantData?.reasonMessage
        // TODO: show search agent failure in modal
        RootStore?.response?.setCustomToast({
          message: message ?? 'Something went wrong',
          color: defaultColors.RED,
          position: ToastPosition.BOTTOM,
          toastType: ToastType.ACTION_VIEW,
        })
      }
    } else if (searchMerchantState === 'rejected') {
      const message = 'Something went wrong'
      RootStore?.response?.setMessage(message)
      onDismiss()
    } else if (searchMerchantState === 'pending') {
      setIsLoading(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchMerchantState])

  // TODO: Remove max retry count restriction on the front-end. It should be from backend
  const handleOnProceed = async () => {
    if (type === 'INIT') {
      if (checked) {
        const getLastTime = await getFromStore('onboardRetryCount')
        console.log('Onboard retry count', getLastTime)
        if (!getLastTime) {
          const startDate = new Date().getTime()
          await storeData('onboardRetryCount', { startDate: startDate, mid: mid, count: 1 })
          onboardAgentApi()
        } else {
          const currentDate = new Date().getTime()
          const user = JSON.parse(getLastTime)
          const startDate = user.startDate
          const count = user.count ?? 1
          const difference = currentDate - startDate
          const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24)
          // update count on next day
          if (daysDifference && daysDifference > 0) {
            await storeData('onboardRetryCount', { startDate: currentDate, mid: mid, count: 1 })
            onboardAgentApi()
          } else if (count < 5) {
            onboardAgentApi()
            await storeData('onboardRetryCount', { startDate: startDate, mid: mid, count: count + 1 })
          } else {
            onDismiss(false)
            RootStore?.response?.setCustomToast({
              message: 'You have reached the maximum attempts. Agent onboard disabled for the day. ',
              color: defaultColors.RED,
              position: ToastPosition.BOTTOM,
              toastType: ToastType.NEGATIVE,
            })
          }
        }
      } else {
        RootStore?.response?.setCustomToast({
          message: 'Please check Terms & Conditions',
          color: defaultColors.RED,
          position: ToastPosition.BOTTOM,
          toastType: ToastType.NEGATIVE,
        })
      }
    } else if (type === 'ACTIVE') {
      naviagateToBillPayment()
    } else {
      onDismiss(false)
    }
  }

  const naviagateToBillPayment = (isTerms?: boolean) => {
    if (isTerms) {
      try {
        return Linking.openURL(APIEndPoints.billpayTnC)
      } catch (error) {
        console.log('failed to open URL', error)
      }
    } else {
      navigation.navigate(Routes.BILL_PAYMENTS as never, { header: 'Bill Payments' } as never)
    }
    onDismiss(false)
  }

  return (
    <Box overflow={'hidden'} {...styles.listWrapper} p={0} minHeight={isLoading ? height - 150 : 150}>
      <ModBox show={isLoading} f={1} align="center" justify="center">
        <Loader type={'small'} color="PRIMARY" />
      </ModBox>
      <ModBox show={!isLoading}>
        <Box
          ph={24}
          pb={6}
          pt={32}
          alignSelf={'flex-end'}
          onPress={() => onDismiss(false)}
          underlayColor={'TRANSPARENT'}>
          <SvgImage imageName="Close" />
        </Box>
        <ScrollView
          contentContainerStyle={styles.scrollContentContainerStyle as ScrollViewProps}
          style={{ height: type !== 'INIT' ? null : height - 170 }}>
          <Box>
            {/* Existing user */}
            <ModBox show={type === 'PENDING'}>
              <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={5}>
                <Box width={'90%'}>
                  <Text fontFamily="JioType-Black" fontSize={24} lineHeight={28}>
                    {modalData[type]?.title}
                  </Text>
                  <Spacer size={16} direction="vertical" />
                  <Text fontFamily="JioType-Medium" lineHeight={20} fontSize={14} color={Colors.PRIMARY_GREY}>
                    {modalData[type]?.description}
                  </Text>
                </Box>
              </Box>
            </ModBox>

            {/* Active agents */}
            <ModBox show={type === 'ACTIVE'}>
              <ActiveUserModal
                onProceedBillPayment={naviagateToBillPayment}
                title={modalData[type]?.title}
                description={modalData[type]?.description}
                iconName={modalData[type]?.iconName}
              />
            </ModBox>

            {/* New agent onboard */}
            <ModBox show={type === 'INIT'}>
              <NewUserModalContent
                onDismiss={onDismiss}
                setIsChecked={setIsChecked}
                checked={checked}
                setShowTerms={() => {
                  // navigate to T&C page of jiopay.in
                  naviagateToBillPayment(true)
                }}
              />
            </ModBox>
          </Box>

          <Box>
            <Spacer size={30} direction="vertical" />
            <Button
              color={'PRIMARY'}
              isFull
              isRound
              onPress={handleOnProceed}
              testID="btn-handleOnProceed"
              height={48}
              underlayColor="PRIMARY"
              disabled={isLoading}
              isLoading={isLoading}>
              <ModBox align="center" justify="center" show={isLoading}>
                <Loader type={'small'} color="WHITE" />
              </ModBox>
              <ModBox align="center" justify="center" show={!isLoading}>
                <Text color="WHITE" fontSize={16} lineHeight={24} fontFamily="JioType-Bold">
                  {modalData[type]?.actionLabel}
                </Text>
              </ModBox>
            </Button>
            <Spacer size={16} direction="vertical" />
          </Box>
        </ScrollView>
      </ModBox>
    </Box>
  )
}

const styles = {
  listWrapper: {
    backgroundColor: 'WHITE',
    p: 24,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
  } as BoxProps,
  scrollContentContainerStyle: {
    flexGrow: 1,
    padding: 24,
    paddingTop: 0,
    justifyContent: 'space-between',
  },
}
